import type { ReactElement } from 'react';

import { PlusPaywall } from 'app/shared-components/PlusPaywall';

export default function SuperLinksPaywall(): ReactElement {
  return (
    <PlusPaywall
      title="See which of your promotional campaigns bring patients in"
      description="Super links take patients straight to a service, product or condition in your pharmacy’s app. Share them anywhere and see how many patients each one brings in."
      benefits={[
        'Link to anything in your app.',
        'Conversion tracking. See total clicks, unique clicks and conversions.',
        'Share them easily as links or QR codes',
      ]}
      image={{ src: '/assets/images/plus-paywall/super-links.webp' }}
    />
  );
}
